import { Provider } from '@angular/core';
import {
  GetVesselClientCodesUseCase,
  GetVesselLandingListUseCase,
  GetVesselNameSuggestionsUseCase,
  GetVesselSchemesUseCase,
} from '@app/application/use-cases/vessel-landing';
import { VesselLandingRepository } from '@app/domain/repositories/vessel-landing.repository';
import { VesselLandingRepositoryImpl } from '../repositories/vessel-landing.repository.impl';

export const VESSEL_LANDING_PROVIDERS: Provider[] = [
  {
    provide: VesselLandingRepository,
    useClass: VesselLandingRepositoryImpl,
  },
  {
    provide: GetVesselLandingListUseCase,
    useFactory: (repo: VesselLandingRepository) =>
      new GetVesselLandingListUseCase(repo),
    deps: [VesselLandingRepository],
  },
  {
    provide: GetVesselNameSuggestionsUseCase,
    useFactory: (repo: VesselLandingRepository) =>
      new GetVesselNameSuggestionsUseCase(repo),
    deps: [VesselLandingRepository],
  },
  {
    provide: GetVesselSchemesUseCase,
    useFactory: (repo: VesselLandingRepository) =>
      new GetVesselSchemesUseCase(repo),
    deps: [VesselLandingRepository],
  },
  {
    provide: GetVesselClientCodesUseCase,
    useFactory: (repo: VesselLandingRepository) =>
      new GetVesselClientCodesUseCase(repo),
    deps: [VesselLandingRepository],
  },
];
